export default () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.207031 10.0002C0.207031 9.44796 0.654746 9.00024 1.20703 9.00024L16.207 9.00024C16.7593 9.00024 17.207 9.44796 17.207 10.0002C17.207 10.5525 16.7593 11.0002 16.207 11.0002L1.20703 11.0002C0.654747 11.0002 0.207031 10.5525 0.207031 10.0002Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.7073 16.5002C13.3167 16.8907 12.6836 16.8907 12.293 16.5002C11.9025 16.1096 11.9025 15.4765 12.293 15.086L16.6717 10.7073C17.0622 10.3168 17.0622 9.68359 16.6717 9.29306L12.293 4.91438C11.9025 4.52386 11.9025 3.89069 12.293 3.50017C12.6836 3.10964 13.3167 3.10964 13.7073 3.50017L19.5002 9.29306C19.8907 9.68359 19.8907 10.3168 19.5002 10.7073L13.7073 16.5002Z"
        fill="white"
      />
    </svg>
  );
};
